export { default as OneColumnDesktopLoginPage } from '../OneColumnDesktopLoginPage/OneColumnDesktopLoginPage'
